export const PROFILE_PHONE_NUMBERS_SUCCESS = 'PROFILE_PHONE_NUMBERS_SUCCESS';
export const PROFILE_PHONE_NUMBERS_LOADING = 'PROFILE_PHONE_NUMBERS_LOADING';
export const PROFILE_PHONE_NUMBERS_ERROR = 'PROFILE_PHONE_NUMBERS_ERROR';